import React, { useEffect, useState } from 'react';
import { ButtonGroup, LoadingButton } from '@atlaskit/button';
import { Checkbox } from '@atlaskit/checkbox';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';

import { SaveSettingsModel } from '../../../../../src/storage/interfaces';
import storageApi from '../../api/storageApi';

import { SettingsBodyWrapper } from './styles';

const SUCCESSFUL_SAVE = true;

type Properties = {
    editedContextId: string;
    editedFieldId: string;
    handleSettingsSave: (isSavedSuccessfully: boolean) => void;
    onClose: () => void;
};

const SettingsModal: React.FC<Properties> = ({ onClose, handleSettingsSave, editedContextId, editedFieldId }) => {
    const [isFetching, setIsFetching] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isAllSelectsRequired, setIsAllSelectsRequired] = useState(false);

    const handleSave = () => {
        setIsSaving(true);
        storageApi
            .saveSettings(editedFieldId, editedContextId, { isAllSelectsRequired })
            .then(() => handleSettingsSave(SUCCESSFUL_SAVE))
            .catch(error => {
                console.error(error.toString());
                handleSettingsSave(!SUCCESSFUL_SAVE);
            });
    };

    useEffect(() => {
        setIsFetching(true);
        storageApi
            .getSettings(editedFieldId, editedContextId)
            .then((settings: SaveSettingsModel) => setIsAllSelectsRequired(settings.isAllSelectsRequired))
            .catch(error => console.error(error.toString()))
            .finally(() => setIsFetching(false));
    }, []);

    return (
        <Modal
            onClose={() => !isSaving && onClose()}
            autoFocus={false}
        >
            <ModalHeader>
                <ModalTitle>Settings</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <SettingsBodyWrapper>
                    {isFetching ?
                        <Spinner size='small' />
                    :   <Checkbox
                            isChecked={isAllSelectsRequired}
                            label={
                                <p>
                                    If the field is required, a user has to fill <strong>all selects</strong> visible on the
                                    dialog.
                                </p>
                            }
                            onChange={() => setIsAllSelectsRequired(!isAllSelectsRequired)}
                            name='checkbox-default'
                        />
                    }
                </SettingsBodyWrapper>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup>
                    <LoadingButton
                        onClick={() => onClose()}
                        appearance='subtle'
                        isLoading={isSaving}
                    >
                        Cancel
                    </LoadingButton>
                    <LoadingButton
                        onClick={handleSave}
                        appearance='primary'
                        isLoading={isSaving}
                    >
                        Save
                    </LoadingButton>
                </ButtonGroup>
            </ModalFooter>
        </Modal>
    );
};

export default SettingsModal;
